<template lang="pug">
  .profile-page.page
    .container
      .profile-page__container
        .profile-page__side.md
          side-nav(
            v-bind:sideNavData="sideNavData"
          )
        .profile-page__main.md
          .profile-page__header
            //.profile-page__title
              h1.title Все смены
            .profile-page__content
              section.form__elem--align-right.form__elem_full
                router-link.button.button_paint-main--transparent(
                to="/pages/director/shift/create"
                )
                  .button__text Создать смену
          .profile-page__body
            director-table(
              :tab_data="test"
              :tab_head="testHead")

    .profile-page__footer.page__footer
      main-footer
</template>
<script>
import {mapState, mapActions} from "vuex";

import MainFooter from "@/components/footer/Footer";
import SideNav from "@/components/sideNav/SideNav";
import DirectorTable from "../components/director-table.vue";

export default {
  name: "DirectorShifts",
  components: {
    DirectorTable,
    SideNav,
    MainFooter
  },
  props: ["sideNavData"],
  data() {
    return {
      testHead: [
        {
          title: "Смена",
          id: 1
        },
        {
          title: "Даты проведения",
          id: 2
        },
        {
          title: "Цена",
          id: 3
        },
        {
          title: "Кол-во человек",
          id: 4
        }
      ],
      test: [
        {
          name: "Смена 1",
          date: "14.08 - 15.09.18",
          price: "10 457 р.",
          number: "90",
          id: 1
        },
        {
          name: "Смена 2",
          date: "14.08 - 15.09.18",
          price: "10 457 р.",
          number: "100",
          id: 2
        },
        {
          name: "Смена 3",
          date: "14.08 - 15.09.18",
          price: "10 457 р.",
          number: "90",
          id: 3
        }
      ]
    };
  }
};
</script>
